import {Input} from 'antd'
  import {Form} from 'antd'
import { FC } from 'react'

interface CommentProps {
}

const Comment: FC<CommentProps> = () => {
    const name = 'comment'

    return (
    <Form.Item name={name} label={'Примечание'}>
        <Input/>
    </Form.Item>
    )
}

export default Comment